import { useTranslation } from 'react-i18next';

export const DerivedSide = ({ values }: { values: any }) => {
	const { t } = useTranslation(['tutorial']);

	return (
		<div className='flex flex-col justify-between pb-2 text-sm'>
			<p className='py-2'>{t('tutorial:derived.definition.preview.line_1')}</p>
			<p className='py-2'>{t('tutorial:derived.definition.preview.line_2')}</p>
			<p className='py-2'>{t('tutorial:derived.definition.preview.line_3')}</p>
		</div>
	);
};
